module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Picture Perf*cked")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005"
    }
  }, [_vm._v("Chapter One: Getting to Know Myself")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006"
    }
  }, [_vm._v("Chapter Two: Ladies Who Brunch")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007"
    }
  }, [_vm._v("Chapter Three: Smoke ’N Mirrors")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: Accepting Adulthood")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#defining-adulthood",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Defining Adulthood")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#failure",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Failure")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#we-are-all-in-this-together",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. We Are All in This\n                        Together")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#people-pleaser",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. People Pleaser")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#no-one-has-it-all",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. No One Has It All")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: The Fuckery Called Expectations")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: Shit Happens")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: Let’s Talk About Sex (and Trying to Have a)\n                Baby!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: C’est La Vie Mum Life")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#the-birthing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The Birthing")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#parenthoodthe-early-days",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Parenthood—The Early Days")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#mum-guilt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Mum Guilt")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: When Life Hits You Sideways")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: Into the Thick of It")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#what-ppd-felt-like-for-me",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. What PPD Felt Like for\n                        Me:")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#staying-quiet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Staying Quiet:")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: To-Do (It All) Lists")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve: Whoosah!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen: Saving the Drama")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen: Tis the Fucking Season")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen: Finding the Funny in Failure")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen: Oh…That ‘Ah-Ha’ Moment")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0